
import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import './App.css';
import EntranceCoordinateCrud from './components/EntranceCoordinateCrud';
import { Dropdown } from 'react-bootstrap';
import AutoTopologyMap from './AutoTopology/AutoTopologyMap';
import Administration from './Administration/Administration';
import DrawingOpticsMap from './Optics/DrawingOpticsMap';
import UpdatingTerritory from './UpdatingTerritory/UpdatingTerritory';
import HomeIcon from '@mui/icons-material/Home';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import TimelineIcon from '@mui/icons-material/Timeline';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import ShareIcon from '@mui/icons-material/Share';
import TitleIcon from '@mui/icons-material/Title';
import RouterIcon from '@mui/icons-material/Router';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import BarChartIcon from '@mui/icons-material/BarChart';
import ListIcon from '@mui/icons-material/List';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import Home from './Optics/Home';
import Command from './Command/Command';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Authorization from './Authorization';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WifiIcon from '@mui/icons-material/Wifi';
import {ROLE_ADMIN, ROLE_OPERATOR, ROLE_MASTER, ROLE_ENGINNER, ROLE_USER, ROLE_DEFAULT, ROLE_SENIOR_MASTER } from './Optics/Constants/ConstantsOptics';
import { Tooltip } from '@mui/material';
import { GET_LOGS_TRAFFIC_API_URL, LOGIN_REFRESH_TOKEN_API_URL } from './Optics/OpticApiConfig';
import {jwtDecode} from 'jwt-decode'; 
import Statistic from './Optics/Statistic/Statistic';
import Nodes from './Nodes/Nodes';
import StorageIcon from '@mui/icons-material/Storage';
import Flood from './Flood/Flood';
import MainConstructorMap from './Construction/MainConstructorMap';
import UpdatingOptic from './UpdatingOptic/UpdatingOptic';
import StatisticOptic from './Optics/Statistic/StatisticOptic';
import ProjectConstructor from './Construction/ProjectConstructor';
import StatisticKtv from './Optics/Statistic/StatisticKtv';
import StatisticRaportIs from './Optics/Statistic/StatisticRaportIs';
import StatisticPillar from './Optics/Statistic/StatisticPillar';
import StatisticWell from './Optics/Statistic/StatisticWell';
import DnsIcon from '@mui/icons-material/Dns';
import { icon30k } from './AutoTopology/constants/MapConstants';
import MainWifiMap from './Wifi/MainWifiMap';
import Statistic3kChain from './Optics/Statistic/Statistic3kСhain';
import Statistic100PabСhain from './Optics/Statistic/Statistic100PabChain';
import Statistic100PabChain from './Optics/Statistic/Statistic100PabChain';
import StatisticSubwaysCanton from './Optics/Statistic/StatisticSubwaysCanton';
import Statistic100pabInEntance from './Optics/Statistic/Statistic100pabInEntance';
import StatisticSubwaysCity from './Optics/Statistic/StatisticSubwaysCity';
import K3Nodes from './Nodes/K3Nodes';

function App() {

  const [token, setToken] = useState(localStorage.getItem('token'));
  const [refreshToken, setRefreshToken] = useState(localStorage.getItem('refreshToken'));
  const [username, setUsername] = useState(localStorage.getItem('username'));
  const [name, setName] = useState(localStorage.getItem('name'));
  const [email, setEmail] = useState(localStorage.getItem('email'));
  const [phone, setPhone] = useState(localStorage.getItem('phone'));
  const [territory, setTerritory] = useState(localStorage.getItem('territory'));
  const [role, setRole] = useState(null);
  const [roleId, setRoleId] = useState(localStorage.getItem('roleId'));
  const hasLoggedRef = useRef(false); 


  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('roleId');
    localStorage.removeItem('name');
    localStorage.removeItem('phone');
    localStorage.removeItem('email');
    setToken(null);
    setRole(null);
    setUsername(null);
    setRoleId(null);
    setName(null);
    setEmail(null);
    setPhone(null);
    setRefreshToken(null);
    hasLoggedRef.current = false;
    window.location.href = '/'; 
  };

   const refreshTokens = async () => {
    // console.log('Начинаем обновление токена...');
    try {
      const response = await fetch(`${LOGIN_REFRESH_TOKEN_API_URL}`, { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({
            refreshToken: refreshToken,
            login: username
          }),
      });
      if (!response.ok) {
        handleLogout();
        return;
      }
      const data = await response.json();
     //  console.log('Новый токен получен:', data.token);
    // console.log('Новый refresh token:', data.refreshToken);
     

      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      localStorage.setItem('username', data.users.username);
      localStorage.setItem('roleId', data.users.roleId);
      localStorage.setItem('name', data.users.name);
      localStorage.setItem('phone', data.users.phone);
      localStorage.setItem('email', data.users.email);

      setToken(data.token);
      setRefreshToken(data.refreshToken);
      setUsername(data.users.username); 
      setName(data.users.name);
      setPhone(data.users.phone);
      setEmail(data.users.email);

      
     // setRoleId(data.users.roleId);     // если есть
    } catch (error) {
     // console.error('Ошибка при обновлении токена:', error);
      handleLogout();
    }
  };

  // Проверяем и обновляем токен при загрузке и по таймеру
  useEffect(() => {
    if (!token) return;

    const decoded = jwtDecode(token);
    const expiresAt = decoded.exp * 1000;
    const now = Date.now();

const timeLeft = expiresAt - now;
//console.log('Текущий токен:', token);
  //  console.log(`Осталось времени до истечения: ${Math.floor(timeLeft / 1000)} секунд`);

    if (expiresAt < now) {
      // Токен уже истёк — обновляем сразу
       // console.log('Токен истёк. Запускаем обновление...');
      refreshTokens();
    } else {
      // Обновляем токен за 1 минуту до истечения
     //  console.log(`Токен ещё действителен. Обновление запланировано через ${Math.floor((timeLeft - 60000) / 1000)} секунд`);
      const timeout = expiresAt - now - 60 * 1000;
      const timerId = setTimeout(() => {
      //   console.log('Время для обновления токена наступило.');
        refreshTokens();
      }, timeout);
       logAttendance(); 

      return () => clearTimeout(timerId);
    }
  }, [token]);



  const getBrowserName = () => {
    const userAgent = navigator.userAgent;
    const browsers = [
      { name: "Edge", condition: userAgent.includes("Edg/") },
      { name: "Chrome", condition: userAgent.includes("Chrome/") },
      { name: "Firefox", condition: userAgent.includes("Firefox/") },
      { name: "Safari", condition: userAgent.includes("Safari/") && !userAgent.includes("Chrome") },
      { name: "Opera", condition: userAgent.includes("Opera/") || userAgent.includes("OPR/") },
    ];
    const browser = browsers.find((b) => b.condition);
    return browser ? browser.name : "Unknown";
  };

  const logAttendance = async () => {
    if (username && roleId && !hasLoggedRef.current) {
      hasLoggedRef.current = true; 
      const currentPage = window.location.pathname;
      try {
        const response = await fetch(`${GET_LOGS_TRAFFIC_API_URL}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: username,
            roleId: roleId,
            currentPage: currentPage,
            browser: getBrowserName(),
          }),
        });

      } catch (error) {
       
      }
    }
  };

  // єто при актуализ сервиса не нужно______________________________________________________________________________________________________
  // useEffect(() => {
  //   if (token) {
  //     try {
  //       // проверка жизни токена
  //       const decoded = jwtDecode(token);
  //       if (decoded.exp * 1000 < Date.now()) {
  //         handleLogout(); 
  //       }
  //     } catch (error) {
  //       console.error('Ошибка при декодировании токена:', error);
  //       handleLogout(); 
  //     }
  //     logAttendance(); 
  //   }
  // }, [token]);

  const parseJwt = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    const tokenFromStorage = localStorage.getItem('token');
    if (tokenFromStorage) {
      setToken(tokenFromStorage);
      const decodedToken = parseJwt(tokenFromStorage);
      setRole(decodedToken?.role);
    }
  }, []);

  useEffect(() => {
   
    setToken(localStorage.getItem('token'));
    setUsername(localStorage.getItem('username'));
    setName(localStorage.getItem('name'));
    setPhone(localStorage.getItem('phone'));
    setEmail(localStorage.getItem('email'));
    setRoleId(localStorage.getItem('roleId'));
  }, []);

  if (!token) {
    return <Authorization setToken={setToken} />;
  }

  return (
  
      <div className='divAuthorization'>

<Navbar expand="lg" className='navbar'>
  {token && (
    <>
      <Navbar.Brand href="/home" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
        <HomeIcon style={{color: '#c4c4c4ff'}}/>{' '} <span style={{fontSize:'14px', color:'#e4e4e4ff'}}>Главная</span>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
        {roleId != ROLE_DEFAULT && (
          <>
          <Nav.Link href="/optic" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
            <TimelineIcon /><span style={{fontSize:'14px'}}> Оптика</span>
          </Nav.Link>
          <Nav.Link href="/autotopology" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
            <AccountTreeIcon /> <span style={{fontSize:'14px'}}>Топология</span>
          </Nav.Link>
          </>
          )}
          {(roleId === ROLE_ADMIN || roleId === ROLE_ENGINNER || roleId === ROLE_MASTER || roleId === ROLE_USER || roleId === ROLE_SENIOR_MASTER) &&  (
          <>
          <Nav.Link href="/wifi" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
              <WifiIcon /><span style={{fontSize:'14px'}}> Wi-Fi</span>
          </Nav.Link>

          <Nav>
         <Dropdown>
         <Dropdown.Toggle
          className="navbarBrand"
          variant="link"
          id="dropdown-activations"
          style={{ textDecoration: 'none',textShadow: '2px 2px 4px #272727'}}
        >
          <ListIcon /> <span style={{fontSize:'14px'}}>Актуализация</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="custom-dropdown-menu">
          <Dropdown.Item
            href="/updatingterritory"
            className="custom-dropdown-item"
            style={{textShadow: '2px 2px 4px #272727'}}
          >
          <EditLocationIcon /> <span style={{fontSize:'14px'}}> Актуализация территории</span>
          </Dropdown.Item>
          <Dropdown.Item
            href="/updatingoptic"
            className="custom-dropdown-item"
            style={{textShadow: '2px 2px 4px #272727'}}
          >
            <ShowChartIcon/><span style={{fontSize:'14px'}}> Актуализация оптики</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </Nav>
          </>
          )}
           {(roleId === ROLE_ADMIN || roleId === ROLE_ENGINNER || roleId === ROLE_USER || roleId === ROLE_SENIOR_MASTER) &&  (
            <>
            <Nav>

             <Dropdown>
              <Dropdown.Toggle
                className="navbarBrand"
                variant="link"
                id="dropdown-activations"
                style={{ textDecoration: 'none', textShadow: '2px 2px 4px #272727' }}
              >
                <EqualizerIcon />  <span style={{fontSize:'14px'}}>Статистика</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="custom-dropdown-menu">
                
                {/* --- Группа: Общая статистика --- */}
                <Dropdown.Header style={{ color: '#ebe0caff', textShadow: '1px 1px 2px #000' }}>
                  Общая статистика
                </Dropdown.Header>
                
                     <Dropdown.Divider
                      style={{
                        marginTop: '1px',
                        marginBottom: '1px',
                        marginLeft: '10px',
                        marginRight: '10px',
                        border: 'none',
                        borderTop: '1px solid #b9a986ff',
                        boxShadow: '0 1px 2px black'
                      }}
                      />

                <Dropdown.Item href="/statistic" className="custom-dropdown-item" style={{textShadow: '2px 2px 4px #131212ff'}}>
                   <EqualizerIcon /> <span style={{fontSize:'14px'}}>Общая</span>
                </Dropdown.Item>

                <Dropdown.Item href="/statisticoptic" className="custom-dropdown-item" style={{textShadow: '2px 2px 4px #131212ff'}}>
                  <BarChartIcon />  <span style={{fontSize:'14px'}}>Актуализация оптики</span>
                </Dropdown.Item>

                <Dropdown.Item href="/statisticraportis" className="custom-dropdown-item" style={{textShadow: '2px 2px 4px #131212ff'}}>
                   <BarChartIcon /> <span style={{fontSize:'14px'}}>Рапорт ИС</span>
                </Dropdown.Item>
                    

              


                {/* --- Группа: КТВ --- */}
                <Dropdown.Header style={{  color: '#ebe0caff', textShadow: '1px 1px 2px #000'  }}>
                  КТВ
                </Dropdown.Header>
                  <Dropdown.Divider
                      style={{
                        marginTop: '1px',
                        marginBottom: '1px',
                        marginLeft: '10px',
                        marginRight: '10px',
                        border: 'none',
                        borderTop: '1px solid #b9a986ff',
                        boxShadow: '0 1px 2px black'
                      }}
                  />

                <Dropdown.Item href="/statisticktv" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                  <ListIcon/><span style={{fontSize:'14px'}}> Усилители</span>
                </Dropdown.Item>


           


                {/* --- Группа: Активка ИНЕТ --- */}
                <Dropdown.Header style={{  color: '#ebe0caff', textShadow: '1px 1px 2px #000' }}>
                  Активка ИНЕТ
                </Dropdown.Header>
                 <Dropdown.Divider
                      style={{
                        marginTop: '1px',
                        marginBottom: '1px',
                        marginLeft: '10px',
                        marginRight: '10px',
                        border: 'none',
                        borderTop: '1px solid #b9a986ff',
                        boxShadow: '0 1px 2px black'
                      }}
                  />

                <Dropdown.Item href="/statistic3kchain" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                  <DnsIcon/><span style={{fontSize:'14px'}}> Паровозы 3К</span>
                </Dropdown.Item>

                <Dropdown.Item href="/statistic100pabchain" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                   <DnsIcon/><span style={{fontSize:'14px'}}> Паровозы 100 ПАБ</span>
                </Dropdown.Item>

                  <Dropdown.Item href="/statistic100pabinentrance" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                   <DnsIcon/><span style={{fontSize:'14px'}}> Больше 2-х свитчей в подъезде</span>
                </Dropdown.Item>
               

                {/* --- Группа: Инфраструктура --- */}
                <Dropdown.Header style={{  color: '#ebe0caff', textShadow: '1px 1px 2px #000'  }}>
                  Инфраструктура
                </Dropdown.Header>
                 <Dropdown.Divider
                      style={{
                        marginTop: '1px',
                        marginBottom: '1px',
                        marginLeft: '10px',
                        marginRight: '10px',
                        border: 'none',
                        borderTop: '1px solid #b9a986ff',
                        boxShadow: '0 1px 2px black'
                      }}
                  />
                <Dropdown.Item href="/statisticsubwayscanton" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                 <ShareIcon/><span style={{fontSize:'14px'}}> Подземки на округе</span>
                </Dropdown.Item>

                <Dropdown.Item href="/statisticsubwayscity" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                 <ShareIcon/><span style={{fontSize:'14px'}}> Подземки город</span>
                </Dropdown.Item>

                <Dropdown.Item href="/statisticpillar" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                 <TitleIcon/><span style={{fontSize:'14px'}}> Опоры</span>
                </Dropdown.Item>

                <Dropdown.Item href="/statisticwell" className="custom-dropdown-item"  style={{textShadow: '2px 2px 4px #131212ff'}}>
                 <BlurCircularIcon/><span style={{fontSize:'14px'}}> Колодцы</span>
                </Dropdown.Item>

              </Dropdown.Menu>
            </Dropdown>

            </Nav>
          </>
          )}


          {(roleId === ROLE_ADMIN || roleId === ROLE_ENGINNER || roleId === ROLE_USER ) &&  (
            <>
            <Nav.Link href="/projectconstruction" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
            <DeviceHubIcon /><span style={{fontSize:'14px'}}> Проекты</span>
            </Nav.Link>

              <Nav>
                <Dropdown>
                <Dropdown.Toggle
                  className="navbarBrand"
                  variant="link"
                  id="dropdown-activations"
                  style={{ textDecoration: 'none',textShadow: '2px 2px 4px #272727'}}
                >
                  <StorageIcon /> <span style={{fontSize:'14px'}}>Оборудование</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown-menu">
                  <Dropdown.Item
                    href="/nodes"
                    className="custom-dropdown-item"
                    style={{textShadow: '2px 2px 4px #272727'}}
                  >
                  <RouterIcon/> <span style={{fontSize:'14px'}}> 30К узлы </span>
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="/3knodes"
                    className="custom-dropdown-item"
                    style={{textShadow: '2px 2px 4px #272727'}}
                  >
                    <StorageIcon/><span style={{fontSize:'14px'}}> 3К узлы</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>





             
          </>
          )}

          {roleId === ROLE_ADMIN && (
            <>
              <Nav>

             <Dropdown>
              <Dropdown.Toggle
                className="navbarBrand"
                variant="link"
                id="dropdown-activations"
                style={{ textDecoration: 'none', textShadow: '2px 2px 4px #272727' }}
              >
                <AdminPanelSettingsIcon /> <span style={{fontSize:'14px'}}>Admin</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="custom-dropdown-menu">

                  <Dropdown.Header style={{ color: '#ebe0caff', textShadow: '1px 1px 2px #000' }}>
                  Управление
                </Dropdown.Header>
                
                     <Dropdown.Divider
                      style={{
                        marginTop: '1px',
                        marginBottom: '1px',
                        marginLeft: '10px',
                        marginRight: '10px',
                        border: 'none',
                        borderTop: '1px solid #b9a986ff',
                        boxShadow: '0 1px 2px black'
                      }}
                      />

                <Dropdown.Item href="/administration" className="custom-dropdown-item" style={{textShadow: '2px 2px 4px #131212ff'}}>
                  <AdminPanelSettingsIcon /><span style={{fontSize:'14px'}}> Администрирование</span>
                </Dropdown.Item>

                <Dropdown.Header style={{ color: '#ebe0caff', textShadow: '1px 1px 2px #000' }}>
                  Engineer
                </Dropdown.Header>
                
                     <Dropdown.Divider
                      style={{
                        marginTop: '1px',
                        marginBottom: '1px',
                        marginLeft: '10px',
                        marginRight: '10px',
                        border: 'none',
                        borderTop: '1px solid #b9a986ff',
                        boxShadow: '0 1px 2px black'
                      }}
                      />
                <Dropdown.Item href="/command" className="custom-dropdown-item" style={{textShadow: '2px 2px 4px #131212ff'}}>
                   <EngineeringIcon /><span style={{fontSize:'14px'}}> Команды</span>
                </Dropdown.Item>

                 <Dropdown.Item href="/flood" className="custom-dropdown-item" style={{textShadow: '2px 2px 4px #131212ff'}}>
                   <ErrorOutlineIcon /><span style={{fontSize:'14px'}} > Флуд</span>
                </Dropdown.Item>

                </Dropdown.Menu>
            </Dropdown>

            </Nav>
            
            {/* <Nav.Link href="/administration" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
              <AdminPanelSettingsIcon /><span style={{fontSize:'14px'}}> Администрирование</span> 
            </Nav.Link>
            <Nav.Link href="/command" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
               <EngineeringIcon /><span style={{fontSize:'14px'}}> Команды</span>
            </Nav.Link>
            <Nav.Link href="/flood" className='navbarBrand' style={{textShadow: '2px 2px 4px #272727'}}>
               <ErrorOutlineIcon /><span style={{fontSize:'14px'}}> Флуд</span>
            </Nav.Link> */}
           </> 
          )}
        </Nav>
        <Navbar.Collapse className="justify-content-end">
          <Tooltip
            title={
              <div style={{ lineHeight: '1.5' }}>
                <span style={{ color: 'white' }}>
                  <span style={{ color: '#e0dfdcff', fontSize: '18px', fontWeight: 'bold' }}>{name}</span><br />
                  <span style={{ color: '#fdcd30ff' }}>({role})</span>
                  <hr style={{marginTop: '5px', marginBottom: '5px'}}/>
                  Логин: <span style={{ color: 'orange' }}>{username}</span><br />
                  Телефон: <span style={{ color: 'orange' }}>{phone}</span><br />
                  Email: <span style={{ color: 'orange' }}>{email}</span>
                  <hr style={{marginTop: '5px', marginBottom: '5px'}}/>
                <span style={{ color: 'white' }}>
            Территория:{' '}
            <span
              style={{
                color:
                  territory && territory.trim().toLowerCase() !== 'null'
                    ? 'orange'
                    : '#ff6c6cff',
                
              }}
            >
              {territory && territory.trim().toLowerCase() !== 'null'
                ? territory
                : 'нет'}
            </span>
          </span>
                </span>
              </div>
            }
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  background: 'linear-gradient(145deg, #000000, #555555)',
                  border: '1px solid orange',
                  color: 'white',
                  fontSize: '14px',
                  borderRadius: '10px',
                  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.8)',
                  padding: '10px 14px',
                },
              },
              arrow: {
                sx: {
                  color: '#333333', // стрелка серо-черная
                },
              },
            }}
          >
          <label
            style={{
              color: 'white',
              marginRight: '10px',
              textShadow: '2px 2px 4px rgb(0, 0, 0)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#ffb347'; // мягкий оранжево-жёлтый
              e.target.style.textShadow =
                '0 0 4px #5c5c5cff, 0 0 8px #0e0e0dff, 0 0 12px #141414ff';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'white';
              e.target.style.textShadow = '2px 2px 4px rgb(0, 0, 0)';
            }}
          >
            {name}
          </label>
  {/* <label
    style={{
      color: 'white',
      marginRight: '10px',
      textShadow: '2px 2px 4px rgb(0, 0, 0)',
      cursor: 'pointer',
    }}
  >
    {username}
  </label> */}
</Tooltip>
          {/* <Tooltip title={`Права: ${name} ${phone}`} arrow>
            <label style={{ color: "white", marginRight: "10px", textShadow: '2px 2px 4px rgb(0, 0, 0)' }}>{username}</label><br/>
           
          </Tooltip> */}
          <Tooltip title="Выйти из аккаунта" arrow>
            <Navbar.Brand onClick={handleLogout} className='navbarBrand' style={{ cursor: 'pointer' }}>
              <ExitToAppIcon />
            </Navbar.Brand>
          </Tooltip>
        </Navbar.Collapse>
      </Navbar.Collapse>
    </>
  )}
</Navbar>
        <Routes>
         <Route path="/" element={<Navigate to="/home" />} />
        {roleId === ROLE_ADMIN && (
           <>
           
             <Route path="/home" element={<Home />} />
             <Route path="/optic" element={<DrawingOpticsMap role={roleId} user={username}/>} />
             <Route path="/autotopology" element={<AutoTopologyMap />} />
             <Route path="/updatingterritory" element={<UpdatingTerritory role={roleId}/>} />
             <Route path="/updatingoptic" element={<UpdatingOptic user={username}/>} />
             <Route path="/projectconstruction" element={<ProjectConstructor user={username}/>} />
             <Route path="/administration" element={<Administration />} />
             <Route path="/statistic" element={<Statistic user={username}/>} />
             <Route path="/statisticoptic" element={<StatisticOptic user={username}/>} />
             <Route path="/statisticraportis" element={<StatisticRaportIs user={username}/>} />
             <Route path="/statisticktv" element={<StatisticKtv user={username}/>} />
             <Route path="/statisticsubwayscanton" element={<StatisticSubwaysCanton user={username}/>} />
             <Route path="/statisticsubwayscity" element={<StatisticSubwaysCity user={username}/>} />
             <Route path="/statisticpillar" element={<StatisticPillar user={username}/>} />
             <Route path="/statisticwell" element={<StatisticWell user={username}/>} />
             <Route path="/statistic3kchain" element={<Statistic3kChain user={username}/>} />
             <Route path="/statistic100pabinentrance" element={<Statistic100pabInEntance user={username}/>} />
             <Route path="/statistic100pabchain" element={<Statistic100PabChain user={username}/>} />
             <Route path="/wifi" element={<MainWifiMap user={username}/>} />
             <Route path="/command" element={<Command/>} />
             <Route path="/nodes" element={<Nodes user={username}/>} />
             <Route path="/3knodes" element={<K3Nodes user={username}/>} />
             <Route path="/flood" element={<Flood role={roleId}/>} />
             <Route path="/constructionmap" element={<MainConstructorMap />} />
           </>
         )}
          {roleId === ROLE_ENGINNER && (
           <>
             <Route path="/home" element={<Home />} />
             <Route path="/optic" element={<DrawingOpticsMap role={roleId} user={username}/>} />
             <Route path="/autotopology" element={<AutoTopologyMap />} />
             <Route path="/updatingterritory" element={<UpdatingTerritory role={roleId}/>} />
             <Route path="/updatingoptic" element={<UpdatingOptic user={username}/>} />
             <Route path="/projectconstruction" element={<ProjectConstructor user={username}/>} />
             <Route path="/statistic" element={<Statistic user={username}/>} />
             <Route path="/statisticoptic" element={<StatisticOptic user={username}/>} />
             <Route path="/statisticraportis" element={<StatisticRaportIs user={username}/>} />
             <Route path="/statisticktv" element={<StatisticKtv user={username}/>} />
             <Route path="/statisticsubwayscanton" element={<StatisticSubwaysCanton user={username}/>} />
             <Route path="/statisticsubwayscity" element={<StatisticSubwaysCity user={username}/>} />
             <Route path="/statisticpillar" element={<StatisticPillar user={username}/>} />
             <Route path="/statisticwell" element={<StatisticWell user={username}/>} />
             <Route path="/statistic3kchain" element={<Statistic3kChain user={username}/>} />
              <Route path="/statistic100pabinentrance" element={<Statistic100pabInEntance user={username}/>} />
             <Route path="/wifi" element={<MainWifiMap user={username}/>} />
             <Route path="/nodes" element={<Nodes user={username}/>} />
             <Route path="/3knodes" element={<K3Nodes user={username}/>} />
             <Route path="/constructionmap" element={<MainConstructorMap />} />
           
           </>
         )}
          {roleId === ROLE_SENIOR_MASTER && (
           <>
             <Route path="/home" element={<Home />} />
             <Route path="/optic" element={<DrawingOpticsMap role={roleId} user={username} />} />
             <Route path="/autotopology" element={<AutoTopologyMap />} />
             <Route path="/updatingterritory" element={<UpdatingTerritory role={roleId}/>} />
             <Route path="/updatingoptic" element={<UpdatingOptic user={username}/>} />
             <Route path="/statistic" element={<Statistic user={username}/>} />
             <Route path="/statisticraportis" element={<StatisticRaportIs user={username}/>} />
             <Route path="/statisticktv" element={<StatisticKtv user={username}/>} />
             <Route path="/statisticoptic" element={<StatisticOptic user={username}/>} />
             <Route path="/statisticsubwayscanton" element={<StatisticSubwaysCanton user={username}/>} />
             <Route path="/statisticpillar" element={<StatisticPillar user={username}/>} />
             <Route path="/statisticwell" element={<StatisticWell user={username}/>} /> 
             <Route path="/statistic3kchain" element={<Statistic3kChain user={username}/>} /> 
             <Route path="/statistic100pabinentrance" element={<Statistic100pabInEntance user={username}/>} />
             <Route path="/wifi" element={<MainWifiMap user={username}/>} />
             <Route path="/constructionmap" element={<MainConstructorMap />} />
           </>
         )}
          {roleId === ROLE_MASTER && (
           <>
             <Route path="/home" element={<Home />} />
             <Route path="/optic" element={<DrawingOpticsMap role={roleId} user={username} />} />
             <Route path="/autotopology" element={<AutoTopologyMap />} />
             <Route path="/wifi" element={<MainWifiMap user={username}/>} />
             <Route path="/updatingoptic" element={<UpdatingOptic user={username}/>} />
             <Route path="/updatingterritory" element={<UpdatingTerritory role={roleId}/>} />
           </>
         )}
         {roleId === ROLE_OPERATOR && (
          <>
             <Route path="/home" element={<Home />} />
             <Route path="/optic" element={<DrawingOpticsMap role={roleId} user={username} />} />
             <Route path="/autotopology" element={<AutoTopologyMap />} />
           </>
        )}
         {roleId === ROLE_USER && (
          <>
             <Route path="/home" element={<Home />} />
             <Route path="/optic" element={<DrawingOpticsMap role={roleId} user={username} />} />
             <Route path="/autotopology" element={<AutoTopologyMap />} />
             <Route path="/updatingterritory" element={<UpdatingTerritory role={roleId}/>}/>
             <Route path="/updatingoptic" element={<UpdatingOptic user={username}/>} />
             <Route path="/statistic" element={<Statistic user={username} />}/>
             <Route path="/statisticoptic" element={<StatisticOptic user={username}/>} />
             <Route path="/statisticraportis" element={<StatisticRaportIs user={username}/>} />
             <Route path="/statisticpillar" element={<StatisticPillar user={username}/>} />
             <Route path="/statisticwell" element={<StatisticWell user={username}/>} />
             <Route path="/projectconstruction" element={<ProjectConstructor user={username}/>}/>
             <Route path="/nodes" element={<Nodes user={username}/>}/>
             <Route path="/flood" element={<Flood user={username}/>}/>
             <Route path="/wifi" element={<MainWifiMap user={username}/>} />

           </>
        )}
         {roleId === ROLE_DEFAULT && (
           <>
             <Route path="/home" element={<Home role={roleId} />} />
           </>
         )}
      </Routes>
      </div>
  
  );
}

export default function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}
